import { render, staticRenderFns } from "./TaskContainer.vue?vue&type=template&id=a17b51c0&scoped=true"
import script from "./TaskContainer.vue?vue&type=script&lang=js"
export * from "./TaskContainer.vue?vue&type=script&lang=js"
import style0 from "./TaskContainer.vue?vue&type=style&index=0&id=a17b51c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a17b51c0",
  null
  
)

export default component.exports